export default "__VITE_ASSET__5bbbd714__"